window.dataLayer = window.dataLayer || [];
const { dataLayer } = window;

/**
 * Overwrite the View On Single Page URL with the permalink with
 * the query strings of the current URL
 */
const overwriteViewOnSinglePageUrl = () => {
  // Get View On Single Page element, and exut the function if it doesn't exist.
  const viewAll = document.querySelector('.post-info__view-full-page');
  if (!viewAll) {
    console.error('Couldn\'t target View All element to set View All URL.');
    return;
  }
  if (!window.s1?.wpDataStack?.pageInfo?.permalink) {
    console.error('window.s1.wpDataStack.pageInfo.permalink is undefined. Couldn\'t Set View All URL.');
    return;
  }

  // Get query strings from current URL
  const searchParams = new URLSearchParams(window.location.search);

  // Replace pagetype value to single, to show the single.php template (hybrid pagetype).
  if (searchParams.has('overridesingularid')) {
    searchParams.set('overridesingularid', 'hybrid');
  } else {
    searchParams.set('utm_pagetype', 'hybrid');
  }

  let viewAllLink = `${window.s1.wpDataStack.pageInfo.permalink}?${searchParams.toString()}`;

  // eslint-disable-next-line no-undef
  if (typeof window.removeUtmParams === 'function') {
    // window.removeUtmParams only appears in ActiveBeat
    // eslint-disable-next-line no-undef
    const newSearchParams = window.removeUtmParams(viewAllLink);
    viewAllLink = `${window.s1.wpDataStack.pageInfo.permalink}${newSearchParams.trim() !== '' ? `?${newSearchParams}` : ''}`;
  }

  // Overwrite the View On One Page URL.
  viewAll.href = viewAllLink;
};

const updateCurrentPageLabel = (currentPage) => {
  document.querySelector('.pagination-nav__current').innerHTML = currentPage + 1;
};

const showHideFeatureImage = (currentPage) => {
  const featureImage = document.querySelector('.featured-image');
  const main = document.getElementById('main');

  if (!featureImage) return;

  if (!window.s1.wpDataStack.pageInfo.wpIsMobile && currentPage === 0) {
    // Show feature image
    featureImage.style.display = 'block';
    if (main) {
      main.classList.remove('main--featuredimage-none');
      main.classList.add('main--featuredimage');
    }
  } else {
    // Hide feature image
    featureImage.style.display = 'none';
    if (main) {
      main.classList.remove('main--featuredimage');
      main.classList.add('main--featuredimage-none');
    }
  }
};

/**
 * Update the History API and provide Custom Event.
 *
 * @param {} data to be saved in the history state.
 * @param String The new title for the page.
 * @param String The URL to put into the address bar.
 * @param {} details The details to be added to the event.
 */
/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-globals */
const updateHistory = (data, title, link, detail, timeSinceLastChange) => {
  // Add the time since the last change
  const currentTime = Date.now();
  detail.timeSinceLastChange = (currentTime - timeSinceLastChange) / 1000;
  timeSinceLastChange = currentTime;

  // Push the new History Entry
  history.pushState(data, title, link);
  // Manually update the title for older browsers
  if (title) {
    document.title = title;
  }

  // Create and fire the Custom Event
  const event = new CustomEvent('urlChange', { detail });
  window.dispatchEvent(event);
};

const updatePageUrl = (currentPage, queryStrings, timeSinceLastChange) => {
  const pathName = window.s1.wpDataStack.pageInfo.permalink;

  let newLink = `${pathName}${currentPage + 1}/?${queryStrings}`;
  // eslint-disable-next-line no-undef
  if (typeof window.removeUtmParams === 'function') {
    // window.removeUtmParams only appears in ActiveBeat
    // eslint-disable-next-line no-undef
    const newSearchParams = window.removeUtmParams(newLink);
    newLink = `${pathName}${currentPage + 1}/${newSearchParams.trim() !== '' ? `?${newSearchParams}` : ''}`;
  }
  updateHistory(null, null, newLink, { pageNumber: currentPage + 1 }, timeSinceLastChange);
};

const updatePrevAndNextLinks = (currentPage, queryStrings) => {
  const pathName = window.s1.wpDataStack.pageInfo.permalink;

  // Update Prev link
  const prevPageLink = document.getElementById('prev-page-link');
  if (prevPageLink && currentPage > 1) {
    let prevLink = `${pathName + currentPage}/?${queryStrings}`;
    // eslint-disable-next-line no-undef
    if (typeof window.removeUtmParams === 'function') {
      // window.removeUtmParams only appears in ActiveBeat
      // eslint-disable-next-line no-undef
      queryStrings = window.removeUtmParams(prevLink);
      prevLink = `${pathName + currentPage}/${queryStrings.trim() !== '' ? `?${queryStrings}` : ''}`;
    }
    prevPageLink.href = prevLink;
  }

  // Update next link.
  const nextPageLink = document.getElementById('next-page-link');
  if (nextPageLink) {
    let nextLink = `${pathName + (currentPage + 2)}/?${queryStrings}`;
    // eslint-disable-next-line no-undef
    if (typeof window.removeUtmParams === 'function') {
      // window.removeUtmParams only appears in ActiveBeat
      // eslint-disable-next-line no-undef
      queryStrings = window.removeUtmParams(nextLink);
      nextLink = `${pathName + (currentPage + 2)}/${queryStrings.trim() !== '' ? `?${queryStrings}` : ''}`;
    }
    nextPageLink.href = nextLink;
    const postInfoRight = document.querySelector('.post-info__right');
    if (postInfoRight) {
      if (currentPage > 0) {
        postInfoRight.classList.add('hide');
      } else {
        postInfoRight.classList.remove('hide');
      }
    }
  }
};

/**
 * Scroll to the highest element on the page (#page-top)
 * Note we are specifically not using window.scrollTo() here.
 * Do not use that! It behaves erratically with how we lazy load images
 * and display ad containers.
 */
const scrollToTop = () => {
  const topOfPage = document.getElementById('page-top');
  console.log('#page-top scrollIntoView()');
  topOfPage.scrollIntoView();
};

const paginatedFluid = () => {
  const isPaginatedFluid = document.querySelector('.main--paginated-2');
  if (isPaginatedFluid) {
    const queryStrings = window.location.href.split('?')[1];
    const timeSinceLastChange = Date.now();
    let currentPage = window.s1.wpDataStack.pageInfo.currentPage
      ? window.s1.wpDataStack.pageInfo.currentPage - 1 : 0;
    const section = document.querySelectorAll('section.content-section');

    // Overwrite VIew All URL
    overwriteViewOnSinglePageUrl();
    // Show current page
    section[currentPage].style.display = 'block';
    // Add Current Page Label.
    updateCurrentPageLabel(currentPage);
    // Show/Hide Feature Image
    showHideFeatureImage(currentPage);
    // update next and previous URLs
    updatePrevAndNextLinks(currentPage, queryStrings);

    // add total pages.
    document.querySelector('.pagination-nav__total').innerHTML = section.length;

    const prevButton = document.querySelector('span.button--pagination-prev');
    // handle multiple next page buttons
    const nextPageButtons = document.querySelectorAll('span.button--pagination-next-page');

    // add previous button click.
    if (prevButton) {
      if (currentPage <= 0) prevButton.classList.add('button--pagination--disabled');

      prevButton.addEventListener('click', (event) => {
        // Trigger a physical page change if there is an interstitial on the page.
        if (window.s1?.prebidUi?.interstitialLoaded) {
          return;
        }
        event.preventDefault();

        section[currentPage].style.display = 'none';
        currentPage--;
        section[currentPage].style.display = 'block';
        scrollToTop();
        updateCurrentPageLabel(currentPage);
        showHideFeatureImage(currentPage);
        updatePageUrl(currentPage, queryStrings, timeSinceLastChange);
        updatePrevAndNextLinks(currentPage, queryStrings);
        if (currentPage === 0) {
          prevButton.classList.add('button--pagination--disabled');
        }
        nextPageButtons.forEach((nextPageButton) => {
          nextPageButton.classList.remove('button--pagination--disabled');
        });
      });
    } else {
      console.error('Could not set previous page selector on the page. Prev page navigation will not work correctly');
    }

    // add next button click.
    if (nextPageButtons.length) {
      nextPageButtons.forEach((nextPageButton) => {
        nextPageButton.addEventListener('click', (event) => {
          // Trigger a physical page change if there is an interstitial on the page.
          if (window.s1?.prebidUi?.interstitialLoaded) {
            return;
          }
          event.preventDefault();

          if (currentPage >= section.length - 1) {
          // next button clicked on the last page. trigger next related article click.
            const nextArticleLink = document.querySelector('span.button--pagination-next-article');

            if (!nextArticleLink) {
            // couldn't get first sidebar article. disable the next button and send error message
            // and end here.
              window.warn('Could not find the most related article. disabling the next button');
              nextPageButtons.forEach((button) => {
                button.classList.add('button--pagination--disabled');
              });
              return;
            }

            // Pass the datalayer event
            dataLayer.push({ event: 'nextArticle' });
            // go to the next article.
            nextArticleLink.click();
            return;
          }

          section[currentPage].style.display = 'none';
          currentPage++;
          if (currentPage < section.length) {
            section[currentPage].style.display = 'block';
          }
          scrollToTop();
          updateCurrentPageLabel(currentPage);
          showHideFeatureImage(currentPage);
          updatePageUrl(currentPage, queryStrings, timeSinceLastChange);
          updatePrevAndNextLinks(currentPage, queryStrings);

          prevButton.classList.remove('button--pagination--disabled');
        });
      });
    } else {
      console.error('Could not set Next page selector on the page. Next page navigation will not work correctly');
    }
  }
};

window.addEventListener('urlChange', () => {
  console.log('url changed');
  dataLayer.push({
    event: 'VirtualPageview',
    virtualUrl: window.location.href,
    page: window.location.pathname,
  });
});

export default paginatedFluid;
